import { render, staticRenderFns } from "./BindAccList.vue?vue&type=template&id=696086b5&scoped=true&"
import script from "./BindAccList.vue?vue&type=script&lang=js&"
export * from "./BindAccList.vue?vue&type=script&lang=js&"
import style0 from "./BindAccList.vue?vue&type=style&index=0&id=696086b5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696086b5",
  null
  
)

export default component.exports